import React from 'react';
import UserManagement from './UserManagement';

const TeamSettings = () => {
  return <UserManagement />;
};

export default TeamSettings;